
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Comment utiliser Google Search Console pour optimiser votre SEO",
    description:
      "La Google Search Console est l’outil incontournable pour analyser et améliorer vos performances SEO. Découvrez comment l'utiliser pour booster votre visibilité.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
